// eslint-disable-next-line import/no-cycle
import { getApi, postApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({
		showSbpList: false,
		chosenBank: null,
		getMoneyMethod: 'sbp',
		sbpBankErrorHeight: 0,
	}),
	mutations: {
		SET_SBP_BANK_ERROR_HEIGHT(state, val) {
			state.sbpBankErrorHeight = val;
		},
		SHOW_SBP_LIST(state) {
			state.showSbpList = true;
		},
		HIDE_SBP_LIST(state) {
			state.showSbpList = false;
		},
		SET_BANK(state, val) {
			state.chosenBank = val;
		},
		SET_GET_MONEY_METHOD(state, val) {
			state.getMoneyMethod = val;
		},
	},
	actions: {
		async getSbpList() {
			const response = await getApi('/k5/v1/contract/get-sbp-members');
			return response;
		},
		// eslint-disable-next-line camelcase,no-empty-pattern,no-unused-vars
		async sendSbpData({}, { sbp_member_id, phone }) {
			const response = await postApi('/k5/v1/contract/set-payout/sbp', {
				sbp_member_id, phone,
			});
			return response;
		},
		// eslint-disable-next-line camelcase,no-empty-pattern
		async sendCardData({}, { card_number, validity_month, validity_year }) {
			const response = await postApi('/api-k3/v2/contract', {
				card_number, validity_month, validity_year,
			});
			return response;
		},
		async requestSignCode() {
			const response = await postApi('/k5/v1/contract/send-code-for-signing');
			return response;
		},
		// eslint-disable-next-line camelcase,no-empty-pattern
		async acceptSignCode({}, { code }) {
			const response = await postApi('/k5/v1/contract/sign', { code });
			return response;
		},
		// // eslint-disable-next-line no-empty-pattern
		// async getMoneyStatus({}, uid) {
		// 	const response = await getApi(`/api-k3/v3/payout/last-for-contract?contract_uid=${uid}`);
		// 	return response;
		// },
		// eslint-disable-next-line no-empty-pattern
		async getMoneyStatus({}, uid) {
			const response = await getApi(`/api-k3/v3/payout/?uid=${uid}`);
			return response;
		},
	},
};
